import React from "react";
import { useQuery } from "@tanstack/react-query";
import { LoadingIndicator } from "../../../common/VFX-UI";
import { CampaignPledgeContainerProps } from "../../../../types/campaignPledge";
import Campaigns from "./Campaigns";
import { employeePledgeApi } from "../../../../app/model/api";

const CampaignsContainer: React.FC<CampaignPledgeContainerProps> = (props) => {
  const campaignGridQuery = useQuery({
    queryKey: ["searchOrganizationCampaign"],
    queryFn: () => employeePledgeApi.getActivePastCampaigns(),
  });

  return campaignGridQuery.isLoading ? (
    <LoadingIndicator />
  ) : (
    <Campaigns
      activeCampaigns={props.activeCampaigns ?? false}
      data={
        campaignGridQuery?.data?.result.filter(
          (campaign) => campaign.campaignStatus === props.activeCampaigns
        ) ?? []
      }
    />
  );
};

export default CampaignsContainer;
